import { Component, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'zikata-frontend-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent {
  @Input() title: string | undefined;
  @Input() errorMessage: string | undefined;

  @Input() description: string | undefined;
  @Input() buttonActionLabel: string | undefined;
  @Input() isLoading = false;
  @Input() resendEmailUrl = '';
  @Output() resend: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() goBack: EventEmitter<undefined> = new EventEmitter<undefined>();
  @Output() formSubmit: EventEmitter<string> = new EventEmitter<string>();

  resetPasswordForm: FormGroup = new FormGroup({ email: new FormControl('', [Validators.required, Validators.email]) });

  onFormSubmit() {
    if (this.resetPasswordForm.invalid) {
      this.errorMessage = 'Please fill in your email address';
      return;
    }
    this.errorMessage = '';
    const email = this.resetPasswordForm.controls['email'].value;
    this.formSubmit.emit(email);
  }
}
